import toKebabCase from '@anwb/poncho/utilities/to-kebab-case';
import { GaFunnelInfo } from 'types/gaFunnelInfo';
import { trackEvent } from 'utils/trackEvent';

export const customOverviewChangeGA4TrackEvent = (
	title: string,
	funnelInfo: GaFunnelInfo
): void => {
	trackEvent({
		event: 'user_interaction',
		type: 'form',
		component: 'change-link',
		action: 'click',
		variant: toKebabCase(title),
		...funnelInfo,
	});
};
